import isNull from 'lodash/isNull';

export const uuidv4 = () => {
  return `${1e7}-${1e3}-${4e3}-${8e3}-${1e11}`.replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16),
  );
};

/**
 * Exposes vue-router to use it with leaflet.js
 * @param {object} router Vue3 router object
 */
export const exposeRouter = (router) => {
  window.vrouter = router;
};

export const toUtcTime = (time) => {
  if (!time) return null;

  const [hours, minutes] = time.split(':').map(Number);
  const today = new Date();
  today.setHours(hours, minutes, 0, 0);

  return [
    today.getUTCHours().toString().padStart(2, '0'),
    today.getUTCMinutes().toString().padStart(2, '0'),
  ].join(':');
}

export const fromUtcTime = (utcTime) => {
  if (!utcTime) return null;
  const [hours, minutes] = utcTime.split(':').map(Number);
  const today = new Date();
  today.setUTCHours(hours, minutes, 0, 0);

  return [
    today.getHours().toString().padStart(2, '0'),
    today.getMinutes().toString().padStart(2, '0'),
  ].join(':');
}

export const isEmpty = (value) => isNull(value) || String(value).length === 0;
